"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const helpers_1 = require("../../lib/helpers");
const InputLabel_1 = __importDefault(require("./Base/InputLabel"));
const InputDiv_1 = __importDefault(require("./Base/InputDiv"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const InputError_1 = __importDefault(require("./Base/InputError"));
const useInputForm_1 = require("../../hooks/useInputForm");
const InputButtonManager_1 = require("./InputButtonManager");
const TextAreaInput = (props) => {
    const { children } = props;
    const primitiveProps = helpers_1.usePrimitiveProps(props);
    const inputFormProps = useInputForm_1.useInputForm(props);
    return (react_1.default.createElement(InputDiv_1.default, { placeholder: props.placeholder, value: props.value, className: props.className, label: props.label, name: props.name, error: props.error },
        react_1.default.createElement(InputLabel_1.default, { className: "retracted" }),
        react_1.default.createElement("textarea", Object.assign({ className: "j-input" }, helpers_1.without(primitiveProps, ['className']), inputFormProps)),
        children,
        react_1.default.createElement(InputButtonManager_1.InputButtonManager, Object.assign({}, props)),
        react_1.default.createElement(InputError_1.default, null)));
};
exports.default = withJourney_1.default('j-text-area-input', TextAreaInput);
